import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { connect } from "react-redux";
import Content from "../ACF/Content";
import { changePageTitle } from "../Redux/slices/currentPage";
import { GET_PAGE_CONTENT, GET_PRODUCTS } from "../apollo";
import PageLoading from "./PageLoading/PageLoading";

const mapDispatchToProps = dispatch => {
    return {
        changePageTitle: payload => dispatch(changePageTitle(payload))
    }
}

const DefaultPage = (props) => {
    const { loading, error, data } = useQuery(GET_PAGE_CONTENT, {
        variables: {
            slug: props.location
        }
    });

    if (loading) {
        return <PageLoading />;
    }

    if (!data.page) {
        return <div className="page page-404">
            <h1 className="title">404 - The page could not be found</h1>
            <span className="text">Sorry, we can't find what you are looking for. Let's get you back on track...</span>
            <Link to="/shop" className="cta">Browse products</Link>
        </div>
    }

    return <div className="page">
        <Content content={data.page.acfContent.pagecustom} />
    </div>
}

export default connect(null, mapDispatchToProps)(DefaultPage);